import Slideshow from './code/Scripts/components/slideshow/slideshow.vue';
import SlideshowNavigation from './code/Scripts/components/slideshowNavigation/slideshow-navigation.vue';

export default {
  components: {
    Slideshow,
    SlideshowNavigation,
  },
};
